/**
 * Used for reakit as the duration of a open/close animation. The animation itself is done using css
 */
export const COMPONENT_ANIMATION_DURATION = 250
